import { SEASON_PASS_CONFIG_SLUG } from "Constants/SeasonPass";

export function getSeasonPassDataPath(): string {
    return `resource/data/${SEASON_PASS_CONFIG_SLUG}`;
}